import { render, staticRenderFns } from "./projectTasksNew.vue?vue&type=template&id=b438458e&scoped=true&"
import script from "./projectTasksNew.vue?vue&type=script&lang=js&"
export * from "./projectTasksNew.vue?vue&type=script&lang=js&"
import style0 from "./projectTasksNew.vue?vue&type=style&index=0&id=b438458e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b438458e",
  null
  
)

export default component.exports